import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/verify-email',
      name: 'verify-email',
      component: () => import(/* webpackChunkName: "verify-email" */ './views/VerifyEmail.vue'),
      beforeEnter: (to, from, next) => {
        document.querySelector('html').classList.remove('bootstrap')

        return next()
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/SignIn.vue'),
      beforeEnter: (to, from, next) => {
        document.querySelector('html').classList.add('bootstrap')

        return next()
      },
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import(/* webpackChunkName: "admin" */ './views/Admin.vue'),
      beforeEnter: (to, from, next) => {
        document.querySelector('html').classList.add('bootstrap')

        if (!store.getters.isLoggedIn)
          return next({
            name: 'login',
            query: {
              redirect: encodeURIComponent(to.path),
            },
          })

        if (to.name === 'admin')
          next({
            name: 'admin.users',
          })

        return next()
      },
      children: [
        {
          path: 'voucher-codes',
          name: 'admin.voucher-codes',
          component: () => import(/* webpackChunkName: "admin.voucher-codes" */ './views/admin/dashboard/VoucherCodes.vue'),
        },
        {
          path: 'users',
          name: 'admin.users',
          component: () => import( /* webpackChunkName: "admin.users" */ './views/admin/dashboard/Users.vue'),
        }
      ],
    },
    {
      path: '/*',
      name: '404',
      component: () => import( /* webpackChunkName: "404" */ './views/Error404.vue'),
      beforeEnter: (to, from, next) => {
        document.querySelector('html').classList.remove('bootstrap')

        return next()
      },
    },
  ],
})
